<template>
  <div 
    :style="{
      transition: `transform ${transitionTime} ease-in-out`,
      transform: `translateX(${translated ? xAxis : '0'}) translateY(${yAxis})`
    }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Translator',
  props: {
    translated: Boolean,
    xAxis: {
      type: String,
      default: '0'
    },
    yAxis: {
      type: String,
      default: '0'
    },
    transitionTime: {
      type: String,
      default: '0.15s'
    }
  },
  data () {
    return {}
  },
}
</script>
